export default "/assets/images/filter-05.b4094e2e5ad582c9.svg";